"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var BackArrowIcon_1 = __importDefault(require("../../../common/Icons/BackArrowIcon"));
var EditIcon_1 = __importDefault(require("../../../common/Icons/EditIcon"));
var ThreeDButton_1 = __importDefault(require("../ThreeDButton"));
var product_1 = require("../../ducks/product");
var withErrorBoundary_1 = __importDefault(require("../../../../decorators/withErrorBoundary"));
var navigation_module_scss_1 = __importDefault(require("./navigation.module.scss"));
var styled_components_1 = __importDefault(require("styled-components"));
var Navigation = function (props) {
    var classes = props.classes, editPath = props.editPath;
    return (react_1.default.createElement("div", { className: navigation_module_scss_1.default.root },
        react_1.default.createElement(IconButton, { className: navigation_module_scss_1.default.back, onClick: props.goBack },
            react_1.default.createElement(BackArrowIcon_1.default, null)),
        react_1.default.createElement(ThreeDButton_1.default, null),
        react_1.default.createElement(IconButton, { className: navigation_module_scss_1.default.edit, onClick: function () {
                window.location.href = editPath;
            } },
            react_1.default.createElement(EditIcon_1.default, { className: navigation_module_scss_1.default.checcIcon }))));
};
var mapStateToProps = function (state) { return ({
    editPath: (0, product_1.editPathSelector)(state),
}); };
var IconButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 12px;\n  height: 48px;\n  border: none;\n  border-radius: 50%;\n  background-color: transparent;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"], ["\n  padding: 12px;\n  height: 48px;\n  border: none;\n  border-radius: 50%;\n  background-color: transparent;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"])));
exports.default = (0, react_redux_1.connect)(mapStateToProps, {
    goBack: product_1.goBack,
})((0, withErrorBoundary_1.default)(Navigation));
var templateObject_1;
